import React, { useContext } from 'react';
import '../../css/button.css'
import Icon from '../../assets/icons/icon';
import { AgentContext } from '../../context/AgentContext';
function PrimaryButton({buttonTitle, buttonLabel, clickHandler, style, disabled = false, leftIconConfigs=null, buttonClass=null, strokeOptions={stroke:null, width: null, lineCap: null, lineJoin:null}}) {
    const handleClick = (e) => {
        if(disabled===false && clickHandler !==undefined){
            clickHandler(e)
        }
    }
    const rootStyle = {
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        display: 'inline-flex',
        cursor: 'pointer',
        flexDirection: 'row',
        ...style
    }
    const {isB2B} = useContext(AgentContext)
    return (
        <>
            {buttonTitle && (
                <div style={{height: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 12, display: 'flex'}}>
                    <div style={{justifyContent: 'flex-start', alignItems: 'flex-end', gap: 4, display: 'inline-flex'}}>
                        <div style={{color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>{buttonTitle}</div>
                    </div>
                </div>
            )}
            <div className={disabled ? (buttonClass ?? `${isB2B ? 'b2b ' : ''}q-primary-button-disabled`) : (buttonClass ?? `${isB2B ? 'b2b ' : ''}q-primary-button`)} onClick={e => handleClick(e)} style={rootStyle}>
                {leftIconConfigs && (
                    <div style={{ display: 'inline-flex', alignItems: 'center', transform: leftIconConfigs.rotate ? 'rotate(180deg)' : null }}>
                        <Icon name={leftIconConfigs.icon} size={leftIconConfigs.size ?? 20} height={leftIconConfigs.height ?? 30} className={""} adjust="fontello" color={leftIconConfigs.color ?? '#F95951'} viewBox={leftIconConfigs.viewBox ?? "0 0 1024 700"} strokeOptions={strokeOptions} pathColor={leftIconConfigs.pathColor ?? ''}/>
                    </div>
                )}
                <div>
                    <div>{buttonLabel}</div>
                </div>
            </div>
        </>
    )
}

export default PrimaryButton;
